/* Gem Solutions — theme.js
 * UI behaviours: image fallback, drawer triggers, gallery thumb swap.
 * AJAX cart lives in cart.js.
 */

(function () {
  'use strict';

  /* ---------- Image error fallback ---------- */
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'IMG') return;
    t.style.opacity = '0';
    var p = t.parentElement;
    if (!p) return;
    p.style.background = 'linear-gradient(135deg, #07291F 0%, #0B3D2E 35%, #15533F 70%, #B8935A 130%)';
    if (!p.dataset.fbk) {
      var label = document.createElement('span');
      label.textContent = '◆';
      label.style.cssText = 'position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:rgba(245,241,232,0.35);font-size:42px;font-family:serif;letter-spacing:0.2em;';
      if (getComputedStyle(p).position === 'static') p.style.position = 'relative';
      p.appendChild(label);
      p.dataset.fbk = '1';
    }
  }, true);

  /* ---------- Drawer open/close (event-delegated) ---------- */
  function openDrawer(e) {
    if (e) e.preventDefault();
    document.body.classList.add('is-cart-open');
  }
  function closeDrawer() {
    document.body.classList.remove('is-cart-open');
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('#cart-toggle, [data-cart-open]');
    if (openTrigger) { openDrawer(e); return; }
    var closeTrigger = e.target.closest('#cart-close, .drawer-backdrop, #drawer-backdrop');
    if (closeTrigger) { closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- PDP gallery — thumbs, arrows, keyboard, swipe ----------
   * Every entry point funnels through activateSlide() so they can never
   * disagree about which slide is live, and so a video can never keep playing
   * on a slide the shopper has navigated away from. */
  function galleryOf(el) {
    return (el && el.closest) ? el.closest('.pdp-gallery') : document.querySelector('.pdp-gallery');
  }
  function gallerySlides(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.pdp-gallery__main .pdp-gallery__slide'));
  }
  function activateSlide(root, id) {
    if (!root || !id) return;
    var index = 0;
    gallerySlides(root).forEach(function (slide, i) {
      var isMatch = slide.dataset.slideId === id;
      if (isMatch) index = i;
      slide.classList.toggle('is-active', isMatch);
      if (!isMatch) {
        var video = slide.querySelector('video');
        if (video) { try { video.pause(); } catch (err) {} }
      }
    });
    root.querySelectorAll('.pdp-gallery__thumbs button').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.thumbId === id);
    });
    var counter = root.querySelector('[data-gallery-index]');
    if (counter) counter.textContent = String(index + 1);
  }
  function stepGallery(root, delta) {
    if (!root) return;
    var slides = gallerySlides(root);
    if (slides.length < 2) return;
    var current = -1;
    slides.forEach(function (s, i) { if (s.classList.contains('is-active')) current = i; });
    if (current < 0) current = 0;
    /* Wraps, so the last image steps forward to the first rather than dead-ending. */
    var next = (current + delta + slides.length) % slides.length;
    activateSlide(root, slides[next].dataset.slideId);
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.pdp-gallery__thumbs button');
    if (thumb && thumb.dataset.thumbId) {
      activateSlide(galleryOf(thumb), thumb.dataset.thumbId);
      return;
    }
    var prev = e.target.closest('[data-gallery-prev]');
    if (prev) { e.preventDefault(); stepGallery(galleryOf(prev), -1); return; }
    var next = e.target.closest('[data-gallery-next]');
    if (next) { e.preventDefault(); stepGallery(galleryOf(next), 1); }
  });

  /* Arrow keys, but never while the shopper is typing or using a video's own
   * scrub controls — stealing those keys there would be hostile. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var root = document.querySelector('.pdp-gallery');
    if (!root) return;
    var t = e.target;
    if (t && t.matches && t.matches('input, textarea, select, video, [contenteditable]')) return;
    if (t && t.isContentEditable) return;
    stepGallery(root, e.key === 'ArrowRight' ? 1 : -1);
  });

  /* Horizontal swipe on the media area. Ignores mostly-vertical drags so it
   * never fights the page scroll. */
  (function () {
    var startX = 0, startY = 0, tracking = false;
    document.addEventListener('touchstart', function (e) {
      var main = e.target && e.target.closest ? e.target.closest('.pdp-gallery__main') : null;
      if (!main || e.touches.length !== 1) { tracking = false; return; }
      tracking = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var touch = e.changedTouches[0];
      if (!touch) return;
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      var main = e.target && e.target.closest ? e.target.closest('.pdp-gallery__main') : null;
      stepGallery(main ? main.closest('.pdp-gallery') : document.querySelector('.pdp-gallery'), dx < 0 ? 1 : -1);
    }, { passive: true });
  })();

  /* ---------- Desktop nav dropdowns — keep panels inside the viewport ----------
   * Decide from layout-stable geometry (item rect + panel offsetWidth, which
   * ignores transforms) rather than the panel's own bounding rect: the panel
   * may be mid-transition or still carrying a flip class from the previous
   * open, so its rect can't be trusted. Mutate classes only when the decision
   * changes (toggle with force) so re-fires never restart transitions. */
  function positionNavDropdown(item) {
    var panel = item.querySelector('.nav__dropdown');
    if (!panel) return;
    var itemRect = item.getBoundingClientRect();
    var panelWidth = panel.offsetWidth;
    var center = itemRect.left + itemRect.width / 2;
    var vw = document.documentElement.clientWidth;
    var overflowRight = center + panelWidth / 2 > vw - 16;
    var overflowLeft = !overflowRight && center - panelWidth / 2 < 16;
    panel.classList.toggle('nav__dropdown--flip-right', overflowRight);
    panel.classList.toggle('nav__dropdown--flip-left', overflowLeft);
  }
  /* mouseenter does not bubble — listen in capture phase */
  document.addEventListener('mouseenter', function (e) {
    if (!e.target || !e.target.closest) return;
    var item = e.target.closest('.nav__item--has-children');
    if (item) positionNavDropdown(item);
  }, true);
  document.addEventListener('focusin', function (e) {
    var item = e.target.closest('.nav__item--has-children');
    if (item) positionNavDropdown(item);
  });

  /* ---------- Mobile nav drawer (event-delegated) ---------- */
  function openMobileNav(e) {
    if (e) e.preventDefault();
    document.body.classList.add('is-mobile-nav-open');
    var ham = document.querySelector('[data-mobile-nav-open]');
    if (ham) ham.setAttribute('aria-expanded', 'true');
    var drawer = document.querySelector('[data-mobile-nav-drawer]');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  }
  function closeMobileNav() {
    document.body.classList.remove('is-mobile-nav-open');
    var ham = document.querySelector('[data-mobile-nav-open]');
    if (ham) ham.setAttribute('aria-expanded', 'false');
    var drawer = document.querySelector('[data-mobile-nav-drawer]');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }
  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-mobile-nav-open]');
    if (openTrigger) { openMobileNav(e); return; }
    var closeTrigger = e.target.closest('[data-mobile-nav-close]');
    if (closeTrigger) { closeMobileNav(); return; }
    /* Submenu disclosure toggle inside the mobile drawer */
    var submenuToggle = e.target.closest('[data-submenu-toggle]');
    if (submenuToggle) {
      e.preventDefault();
      var targetId = submenuToggle.getAttribute('aria-controls');
      var submenu = targetId ? document.getElementById(targetId) : null;
      if (submenu) {
        var isOpen = submenuToggle.getAttribute('aria-expanded') === 'true';
        submenuToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) {
          submenu.setAttribute('hidden', '');
        } else {
          submenu.removeAttribute('hidden');
        }
      }
      return;
    }
    /* Close drawer when tapping any link inside it (so user lands on the new page with a clean state) */
    var linkInDrawer = e.target.closest('.mobile-nav-drawer__panel a');
    if (linkInDrawer) { closeMobileNav(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('is-mobile-nav-open')) closeMobileNav();
  });

  /* ---------- PLP filter rail (off-canvas drawer below 880px) + sort ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-open]')) { e.preventDefault(); document.body.classList.add('is-plp-filter-open'); return; }
    if (e.target.closest('[data-overlay-close]')) { document.body.classList.remove('is-plp-filter-open'); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.body.classList.remove('is-plp-filter-open');
  });
  /* Sort select submits its form immediately, carrying current filter state with it */
  document.addEventListener('change', function (e) {
    var sortSelect = e.target.closest('[data-sort-select]');
    if (sortSelect && sortSelect.form) sortSelect.form.submit();
  });

  /* ---------- Bespoke inquiry modal (event-delegated) ---------- */
  function openBespoke(e) {
    if (e) e.preventDefault();
    document.body.classList.add('is-bespoke-open');
    var firstInput = document.querySelector('[data-bespoke-modal] input[name="contact[name]"]');
    if (firstInput) setTimeout(function () { firstInput.focus(); }, 200);
  }
  function closeBespoke() {
    document.body.classList.remove('is-bespoke-open');
  }
  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-bespoke-open]');
    if (openTrigger) { openBespoke(e); return; }
    var closeTrigger = e.target.closest('[data-bespoke-close]');
    if (closeTrigger) { closeBespoke(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('is-bespoke-open')) closeBespoke();
  });

  /* Auto-open the modal if Shopify just posted the contact form successfully from it */
  if (window.location.hash === '#bespoke-success' || document.querySelector('[data-bespoke-modal] .form-status--posted, [data-bespoke-modal] form[data-success]')) {
    document.addEventListener('DOMContentLoaded', openBespoke);
  }

  /* Expose openers for cart.js to call after add-to-cart */
  window.GemSolutions = window.GemSolutions || {};
  window.GemSolutions.openCartDrawer = openDrawer;
  window.GemSolutions.closeCartDrawer = closeDrawer;
  window.GemSolutions.openBespokeModal = openBespoke;
  window.GemSolutions.closeBespokeModal = closeBespoke;

  /* ---------- PDP share — copy link button ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share-copy]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-share-url') || window.location.href;
    var feedback = btn.querySelector('.pdp-share__feedback');
    function flash(msg) {
      if (!feedback) return;
      feedback.textContent = msg;
      btn.classList.add('is-copied');
      setTimeout(function () {
        btn.classList.remove('is-copied');
        feedback.textContent = '';
      }, 1800);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(
        function () { flash('Copied'); },
        function () { flash('Press Ctrl+C'); }
      );
    } else {
      /* Old-browser fallback: select a temporary textarea, execCommand */
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); flash('Copied'); }
      catch (err) { flash('Press Ctrl+C'); }
      document.body.removeChild(ta);
    }
  });
})();
